// Translations for all 6 supported languages: pt-PT, pt-BR, es, de, en, it
export const LANGUAGES = [
  { code: "pt-PT", label: "Português (PT)", flag: "PT" },
  { code: "pt-BR", label: "Português (BR)", flag: "BR" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "en", label: "English", flag: "EN" },
  { code: "it", label: "Italiano", flag: "IT" },
];

export const translations = {
  "pt-PT": {
    app: {
      title: "Primo",
      subtitle: "Simulador de Poupança — Vedações para Reboques Refrigerados",
      newSimulation: "Nova Simulação",
      savedSimulations: "Simulações Guardadas",
      settings: "Definições",
      language: "Idioma",
    },
    home: {
      heroTag: "Sistema de Vedação de Portas Traseiras",
      heroTitle: "Quantifique a poupança na sua produção",
      heroBody: "Uma ferramenta visual e faseada para comparar, lado a lado, o custo actual da sua produção e a poupança obtida ao adoptar a solução Primo.",
      startBtn: "Iniciar Simulação",
      viewSavedBtn: "Ver simulações guardadas",
      stat1: "Poupança média",
      stat2: "Tempo poupado",
      stat3: "Idiomas",
      per: "por 2 portas",
    },
    phases: {
      p1: "Configuração",
      p2: "Custos Actuais",
      p3: "Solução Primo",
      p4: "Antes vs Depois",
      p5: "Resultado",
      phaseOf: "Fase {n} de 5",
    },
    common: {
      back: "Voltar",
      next: "Continuar",
      finish: "Ver Resultado",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      close: "Fechar",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "unid.",
      required: "Campo obrigatório",
      saved: "Simulação guardada",
      duplicated: "Simulação duplicada",
      deleted: "Simulação eliminada",
      loading: "A carregar…",
      empty: "Sem simulações guardadas.",
      error: "Ocorreu um erro.",
      clientRequired: "Introduza o nome do cliente antes de guardar ou exportar.",
      exportPdf: "Exportar PDF",
      restart: "Nova Simulação",
      goToPhase: "Ir para fase",
      created: "Criada",
      subtotal: "Subtotal",
    },
    client: {
      title: "Informação do Cliente",
      subtitle: "Identifique o cliente com quem está a fazer a apresentação",
      company: "Nome da empresa",
      companyPh: "Ex: TransRefrigerados Lda.",
      contact: "Pessoa de contacto",
      contactPh: "Ex: João Silva",
      email: "Email (opcional)",
      emailPh: "joao@empresa.pt",
      notes: "Notas internas",
      notesPh: "Observações da reunião…",
    },
    trailer: {
      title: "Características do Reboque",
      subtitle: "Configure as dimensões e o volume de produção",
      height: "Altura da porta",
      width: "Largura da porta",
      doors: "Portas por reboque",
      fleet: "Frota do cliente (nº reboques)",
      annual: "Nº de reboques produzidos",
      period: "Período de produção",
      weekly: "Semanal",
      monthly: "Mensal",
      annualPeriod: "Anual",
      quantityHint: "Quantidade de reboques novos produzidos por {period} (não confundir com o tamanho da frota)",
      hint: "Valores por defeito baseados nas dimensões standard: 2600 × 1200 mm.",
      layoutTitle: "Porta Esquerda + Porta Direita",
      layoutBody: "Cada reboque leva dois frames diferentes. O Frame A (esquerda) tem vedação (18mm ±2) nas 3 extremidades exteriores (5.0m) mais o perfil central (25mm ±2) ao centro (2.6m). O Frame B (direita) leva apenas vedação em todo o perímetro (7.6m) e sela contra o perfil central do Frame A. Contabiliza-se por par (2 frames = 1 reboque).",
      dimensionsDiffer: "Dimensões diferentes por porta",
      leftDim: "Porta Esquerda",
      rightDim: "Porta Direita",

      profileSection: "Perfil / Espessura da borracha",
      profilePreset: "Perfil (mm)",
      profileChoose: "Escolher perfil",
      profileHint: "Selecionar um perfil pré-preenche os custos das etapas seguintes.",
      hourlyRate: "Valor hora (mão-de-obra)",
      hourlyRateHint: "Aplicado a todas as operações. Custo = tempo × €/h.",
      hourlyRateSection: "Custo da Mão-de-obra",
      managePresets: "Gerir perfis",    },
    customer: {
      title: "Custos Actuais do Cliente",
      subtitle: "Solução actualmente utilizada — introduza os valores praticados",
      profiles: "Perfis (por metro)",
      doorsealing: "Vedação de porta",
      centerprofile: "Perfil central",
      labor: "Mão-de-obra",
      cuttingTime: "Corte",
      gluing: "Colagem de cantos",
      mounting: "Montagem",
      timeMin: "Tempo",
      cost: "Custo",
      steelband: "Steel band + fixação",
      steelbandPrice: "Preço steel band (2×)",
      steelbandPricePerM: "Preço steel band",
      steelbandLengthA: "Comprimento A",
      steelbandLengthB: "Comprimento B",
      drilling: "Furação",
      popniets: "Rebites (popniets)",
      totalPrice: "Preço total (2 portas)",
      totalTime: "Tempo total (2 portas)",
      hint: "Estes valores representam a situação actual — o cenário «Antes».",
      sidesDiffer: "Distinguir porta esquerda e direita",
      leftDoor: "Porta Esquerda · vedação + perfil central",
      rightDoor: "Porta Direita · só vedação",
      frameALenHint: "5.0m de vedação + 2.6m de perfil central",
      frameBLenHint: "7.6m de vedação (sem perfil central — sela contra porta esquerda)",
    },
    primo: {
      title: "Solução Primo",
      subtitle: "Valores da nossa solução — pode ajustar conforme a proposta",
      profiles: "Perfis (por metro)",
      doorsealing: "Vedação de porta",
      centerprofile: "Perfil central",
      labor: "Mão-de-obra",
      weldingCutting: "Soldadura & corte",
      gluing: "Colagem",
      mounting: "Montagem",
      glue: "Cola/material (por porta)",
      totalPrice: "Preço total (2 portas)",
      totalTime: "Tempo total (2 portas)",
      hint: "Sem steel band. Solução pré-fabricada e mais rápida de instalar.",
    },
    compare: {
      title: "Antes vs Depois",
      subtitle: "Antes e depois — por 2 portas",
      current: "Situação Actual",
      primoSolution: "Solução Primo",
      priceBreakdown: "Composição de custo",
      timeBreakdown: "Composição de tempo",
      profiles: "Perfis",
      labor: "Mão-de-obra",
      materials: "Materiais",
      steelband: "Steel band",
    },
    reveal: {
      title: "Resultado da Simulação",
      subtitle: "A poupança que o seu cliente irá obter",
      pricePerSet: "Poupança por 2 portas",
      timePerSet: "Poupança de tempo por 2 portas",
      annualSavings: "Poupança anual estimada",
      fleetSavings: "Poupança total na frota",
      currentCost: "Custo actual",
      newCost: "Custo com Primo",
      reductionOf: "Redução de",
      timeReduction: "Redução de tempo",
      basedOn: "Baseado em {fleet} reboque(s) × {doors} portas × {annual} unid./ano",
      congrats: "Poupança demonstrada",
      cta: "Guardar & Exportar",
      shareTitle: "Partilhar apresentação",
    },
    saved: {
      title: "Simulações Guardadas",
      subtitle: "Consulte e recupere simulações anteriores",
      newBtn: "+ Nova Simulação",
      search: "Pesquisar por cliente…",
      open: "Abrir",
      duplicate: "Duplicar",
      copySuffix: "(Cópia)",
      empty: "Ainda não há simulações guardadas.",
      confirmDelete: "Eliminar simulação?",
      deleteWarning: "Esta acção não pode ser desfeita.",
    },
    pdf: {
      headerTitle: "Análise Técnica de Custos",
      headerSubtitle: "Vedação de portas traseiras · relatório de poupança",
      s1: "§1 Dados do cliente e reboque",
      client: "Cliente",
      contact: "Contacto",
      email: "Email",
      production: "Produção",
      doorHeight: "Altura da porta",
      doorWidth: "Largura da porta",
      doorsPerTrailer: "Portas / reboque",
      profile: "Perfil",
      notes: "Notas",
      s2: "§2 Configuração das portas",
      leftDoor: "Porta Esquerda",
      rightDoor: "Porta Direita",
      leftDoorDesc: "Vedação {t}mm nas 3 extremidades exteriores + perfil central {t}mm na extremidade interior.",
      rightDoorDesc: "Vedação {t}mm em todo o perímetro. Sela contra o perfil central da porta esquerda.",
      dsLength: "Comprimento vedação",
      cpLength: "Comprimento perfil central",
      s3: "§3 Decomposição de custos",
      component: "Componente",
      customer: "Cliente",
      primo: "Primo",
      savings: "Δ Poupança",
      leftDoorProfiles: "Porta Esquerda · vedação + perfil central",
      rightDoorProfiles: "Porta Direita · só vedação",
      cuttingWelding: "Corte / soldadura & corte",
      cornerGluing: "Colagem de cantos",
      mounting: "Montagem",
      steelbandRow: "Steel band + furação + rebites",
      glueRow: "Cola / material",
      eliminated: "— eliminado",
      totalSet: "Total (por conjunto de {n} portas)",
      s4: "§4 Tempo de mão-de-obra",
      operation: "Operação",
      totalLabour: "Tempo total mão-de-obra",
      s5: "§5 Resumo de poupança",
      perSet: "Por conjunto ({n} portas)",
      annualised: "Anualizado",
      costReduction: "redução de custo",
      saved: "poupado",
      // ---- Executive / Visual report ----
      execTitle: "Resumo Executivo",
      execHeroLabel: "Poupança demonstrada",
      execPerDoors: "por {n} portas",
      execCompareTitle: "Sem Primo vs Com Primo",
      beforePrimo: "Sem Primo",
      afterPrimo: "Com Primo",
      cost: "Custo",
      time: "Tempo",
      costSavings: "Poupança em Custo",
      timeSavings: "Poupança em Tempo",
      projectionPeriod: "Projecção {period}",
      projectionAnnual: "Projecção Anualizada",
      fleetTotalSavings: "Poupança total na frota",
      technicalDetail: "Detalhe Técnico",
    },
  },

  "pt-BR": {
    app: {
      title: "Primo",
      subtitle: "Simulador de Economia — Vedações para Reboques Refrigerados",
      newSimulation: "Nova Simulação",
      savedSimulations: "Simulações Salvas",
      settings: "Configurações",
      language: "Idioma",
    },
    home: {
      heroTag: "Sistema de Vedação de Portas Traseiras",
      heroTitle: "Quantifique a economia na sua produção",
      heroBody: "Uma ferramenta visual e faseada para comparar, lado a lado, o custo atual da sua produção e a economia obtida ao adotar a solução Primo.",
      startBtn: "Iniciar Simulação",
      viewSavedBtn: "Ver simulações salvas",
      stat1: "Economia média",
      stat2: "Tempo economizado",
      stat3: "Idiomas",
      per: "por 2 portas",
    },
    phases: {
      p1: "Configuração",
      p2: "Custos Atuais",
      p3: "Solução Primo",
      p4: "Antes vs Depois",
      p5: "Resultado",
      phaseOf: "Fase {n} de 5",
    },
    common: {
      back: "Voltar",
      next: "Continuar",
      finish: "Ver Resultado",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      close: "Fechar",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "unid.",
      required: "Campo obrigatório",
      saved: "Simulação salva",
      duplicated: "Simulação duplicada",
      deleted: "Simulação excluída",
      loading: "Carregando…",
      empty: "Sem simulações salvas.",
      error: "Ocorreu um erro.",
      clientRequired: "Informe o nome do cliente antes de salvar ou exportar.",
      exportPdf: "Exportar PDF",
      restart: "Nova Simulação",
      goToPhase: "Ir para fase",
      created: "Criada em",
      subtotal: "Subtotal",
    },
    client: {
      title: "Informação do Cliente",
      subtitle: "Identifique o cliente da apresentação",
      company: "Nome da empresa",
      companyPh: "Ex: TransRefrigerados Ltda.",
      contact: "Pessoa de contato",
      contactPh: "Ex: João Silva",
      email: "Email (opcional)",
      emailPh: "joao@empresa.com.br",
      notes: "Notas internas",
      notesPh: "Observações da reunião…",
    },
    trailer: {
      title: "Características do Reboque",
      subtitle: "Configure as dimensões e o volume de produção",
      height: "Altura da porta",
      width: "Largura da porta",
      doors: "Portas por reboque",
      fleet: "Frota do cliente (nº reboques)",
      annual: "Nº de reboques produzidos",
      period: "Período de produção",
      weekly: "Semanal",
      monthly: "Mensal",
      annualPeriod: "Anual",
      quantityHint: "Quantidade de reboques novos produzidos por {period} (não confundir com o tamanho da frota)",
      hint: "Valores padrão baseados nas dimensões: 2600 × 1200 mm.",
      layoutTitle: "Porta Esquerda + Porta Direita",
      layoutBody: "Cada reboque leva dois frames diferentes. O Frame A (esquerda) tem vedação (18mm ±2) nas 3 extremidades externas (5.0m) mais o perfil central (25mm ±2) no centro (2.6m). O Frame B (direita) leva apenas vedação em todo o perímetro (7.6m) e sela contra o perfil central do Frame A. Contabiliza-se por par (2 frames = 1 reboque).",
      dimensionsDiffer: "Dimensões diferentes por porta",
      leftDim: "Porta Esquerda",
      rightDim: "Porta Direita",

      profileSection: "Perfil / Espessura da borracha",
      profilePreset: "Perfil (mm)",
      profileChoose: "Selecionar perfil",
      profileHint: "Selecionar um perfil preenche automaticamente os custos das próximas etapas.",
      hourlyRate: "Valor hora (mão de obra)",
      hourlyRateHint: "Aplicado a todas as operações. Custo = tempo × €/h.",
      hourlyRateSection: "Custo da Mão de Obra",
      managePresets: "Gerenciar perfis",    },
    customer: {
      title: "Custos Atuais do Cliente",
      subtitle: "Solução em uso — insira os valores atuais",
      profiles: "Perfis (por metro)",
      doorsealing: "Vedação de porta",
      centerprofile: "Perfil central",
      labor: "Mão de obra",
      cuttingTime: "Corte",
      gluing: "Colagem de cantos",
      mounting: "Montagem",
      timeMin: "Tempo",
      cost: "Custo",
      steelband: "Steel band + fixação",
      steelbandPrice: "Preço steel band (2×)",
      steelbandPricePerM: "Preço steel band",
      steelbandLengthA: "Comprimento A",
      steelbandLengthB: "Comprimento B",
      drilling: "Furação",
      popniets: "Rebites (popniets)",
      totalPrice: "Preço total (2 portas)",
      totalTime: "Tempo total (2 portas)",
      hint: "Estes valores representam o cenário «Antes».",
      sidesDiffer: "Distinguir porta esquerda e direita",
      leftDoor: "Porta Esquerda · vedação + perfil central",
      rightDoor: "Porta Direita · só vedação",
      frameALenHint: "5.0m de vedação + 2.6m de perfil central",
      frameBLenHint: "7.6m de vedação (sem perfil central — sela contra porta esquerda)",
    },
    primo: {
      title: "Solução Primo",
      subtitle: "Valores da nossa solução — ajustáveis conforme proposta",
      profiles: "Perfis (por metro)",
      doorsealing: "Vedação de porta",
      centerprofile: "Perfil central",
      labor: "Mão de obra",
      weldingCutting: "Soldagem & corte",
      gluing: "Colagem",
      mounting: "Montagem",
      glue: "Cola/material (por porta)",
      totalPrice: "Preço total (2 portas)",
      totalTime: "Tempo total (2 portas)",
      hint: "Sem steel band. Solução pré-fabricada e mais rápida.",
    },
    compare: {
      title: "Antes vs Depois",
      subtitle: "Antes e depois — por 2 portas",
      current: "Situação Atual",
      primoSolution: "Solução Primo",
      priceBreakdown: "Composição de custo",
      timeBreakdown: "Composição de tempo",
      profiles: "Perfis",
      labor: "Mão de obra",
      materials: "Materiais",
      steelband: "Steel band",
    },
    reveal: {
      title: "Resultado da Simulação",
      subtitle: "A economia que seu cliente terá",
      pricePerSet: "Economia por 2 portas",
      timePerSet: "Economia de tempo por 2 portas",
      annualSavings: "Economia anual estimada",
      fleetSavings: "Economia total na frota",
      currentCost: "Custo atual",
      newCost: "Custo com Primo",
      reductionOf: "Redução de",
      timeReduction: "Redução de tempo",
      basedOn: "Baseado em {fleet} reboque(s) × {doors} portas × {annual} unid./ano",
      congrats: "Economia demonstrada",
      cta: "Salvar & Exportar",
      shareTitle: "Compartilhar apresentação",
    },
    saved: {
      title: "Simulações Salvas",
      subtitle: "Consulte e recupere simulações anteriores",
      newBtn: "+ Nova Simulação",
      search: "Pesquisar por cliente…",
      open: "Abrir",
      duplicate: "Duplicar",
      copySuffix: "(Cópia)",
      empty: "Ainda não há simulações salvas.",
      confirmDelete: "Excluir simulação?",
      deleteWarning: "Esta ação não pode ser desfeita.",
    },
    pdf: {
      headerTitle: "Análise Técnica de Custos",
      headerSubtitle: "Vedação de portas traseiras · relatório de economia",
      s1: "§1 Dados do cliente e reboque",
      client: "Cliente", contact: "Contato", email: "Email", production: "Produção",
      doorHeight: "Altura da porta", doorWidth: "Largura da porta", doorsPerTrailer: "Portas / reboque", profile: "Perfil",
      notes: "Notas",
      s2: "§2 Configuração das portas", leftDoor: "Porta Esquerda", rightDoor: "Porta Direita",
      leftDoorDesc: "Vedação {t}mm nas 3 extremidades externas + perfil central {t}mm na borda interna.",
      rightDoorDesc: "Vedação {t}mm em todo o perímetro. Veda contra o perfil central da porta esquerda.",
      dsLength: "Comprimento vedação", cpLength: "Comprimento perfil central",
      s3: "§3 Decomposição de custos", component: "Componente", customer: "Cliente", primo: "Primo", savings: "Δ Economia",
      leftDoorProfiles: "Porta Esquerda · vedação + perfil central", rightDoorProfiles: "Porta Direita · só vedação",
      cuttingWelding: "Corte / soldagem & corte", cornerGluing: "Colagem de cantos", mounting: "Montagem",
      steelbandRow: "Steel band + furação + rebites", glueRow: "Cola / material", eliminated: "— eliminado",
      totalSet: "Total (por conjunto de {n} portas)",
      s4: "§4 Tempo de mão de obra", operation: "Operação", totalLabour: "Tempo total mão de obra",
      s5: "§5 Resumo de economia", perSet: "Por conjunto ({n} portas)", annualised: "Anualizado",
      costReduction: "redução de custo", saved: "economizado",
      execTitle: "Resumo Executivo", execHeroLabel: "Economia demonstrada",
      execPerDoors: "por {n} portas", execCompareTitle: "Sem Primo vs Com Primo",
      beforePrimo: "Sem Primo", afterPrimo: "Com Primo",
      cost: "Custo", time: "Tempo",
      costSavings: "Economia em Custo", timeSavings: "Economia em Tempo",
      projectionPeriod: "Projeção {period}", projectionAnnual: "Projeção Anualizada",
      fleetTotalSavings: "Economia total na frota", technicalDetail: "Detalhe Técnico",
    },
  },

  "es": {
    app: {
      title: "Primo",
      subtitle: "Simulador de Ahorro — Sellados para Remolques Refrigerados",
      newSimulation: "Nueva Simulación",
      savedSimulations: "Simulaciones Guardadas",
      settings: "Ajustes",
      language: "Idioma",
    },
    home: {
      heroTag: "Sistema de Sellado de Puertas Traseras",
      heroTitle: "Cuantifica el ahorro en tu producción",
      heroBody: "Una herramienta visual y por fases para comparar, lado a lado, el coste actual de tu producción y el ahorro obtenido al adoptar la solución Primo.",
      startBtn: "Iniciar Simulación",
      viewSavedBtn: "Ver simulaciones guardadas",
      stat1: "Ahorro medio",
      stat2: "Tiempo ahorrado",
      stat3: "Idiomas",
      per: "por 2 puertas",
    },
    phases: {
      p1: "Configuración",
      p2: "Costes Actuales",
      p3: "Solución Primo",
      p4: "Antes vs Después",
      p5: "Resultado",
      phaseOf: "Fase {n} de 5",
    },
    common: {
      back: "Atrás",
      next: "Continuar",
      finish: "Ver Resultado",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      close: "Cerrar",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "unid.",
      required: "Campo obligatorio",
      saved: "Simulación guardada",
      duplicated: "Simulación duplicada",
      deleted: "Simulación eliminada",
      loading: "Cargando…",
      empty: "Sin simulaciones guardadas.",
      error: "Ocurrió un error.",
      clientRequired: "Introduce el nombre del cliente antes de guardar o exportar.",
      exportPdf: "Exportar PDF",
      restart: "Nueva Simulación",
      goToPhase: "Ir a fase",
      created: "Creada",
      subtotal: "Subtotal",
    },
    client: {
      title: "Información del Cliente",
      subtitle: "Identifica al cliente de la presentación",
      company: "Nombre de la empresa",
      companyPh: "Ej: TransRefrigerados S.L.",
      contact: "Persona de contacto",
      contactPh: "Ej: Juan García",
      email: "Correo (opcional)",
      emailPh: "juan@empresa.es",
      notes: "Notas internas",
      notesPh: "Observaciones de la reunión…",
    },
    trailer: {
      title: "Características del Remolque",
      subtitle: "Configura las dimensiones y el volumen de producción",
      height: "Altura de la puerta",
      width: "Ancho de la puerta",
      doors: "Puertas por remolque",
      fleet: "Flota del cliente (nº remolques)",
      annual: "Nº de remolques producidos",
      period: "Período de producción",
      weekly: "Semanal",
      monthly: "Mensual",
      annualPeriod: "Anual",
      quantityHint: "Cantidad de remolques nuevos producidos por {period} (no confundir con el tamaño de la flota)",
      hint: "Valores por defecto: 2600 × 1200 mm.",
      layoutTitle: "Puerta Izquierda + Puerta Derecha",
      layoutBody: "Cada remolque lleva dos marcos distintos. El Frame A (izquierda) tiene sellado (18mm ±2) en las 3 aristas exteriores (5.0m) más el perfil central (25mm ±2) en el centro (2.6m). El Frame B (derecha) lleva únicamente sellado en todo el perímetro (7.6m) y sella contra el perfil central del Frame A. Se contabiliza por par (2 marcos = 1 remolque).",
      dimensionsDiffer: "Dimensiones distintas por puerta",
      leftDim: "Puerta Izquierda",
      rightDim: "Puerta Derecha",

      profileSection: "Perfil / Espesor de la goma",
      profilePreset: "Perfil (mm)",
      profileChoose: "Elegir perfil",
      profileHint: "Seleccionar un perfil rellena automáticamente los costes de las etapas siguientes.",
      hourlyRate: "Coste hora (mano de obra)",
      hourlyRateHint: "Aplicado a todas las operaciones. Coste = tiempo × €/h.",
      hourlyRateSection: "Coste de Mano de Obra",
      managePresets: "Gestionar perfiles",    },
    customer: {
      title: "Costes Actuales del Cliente",
      subtitle: "Solución actual — introduce los valores",
      profiles: "Perfiles (por metro)",
      doorsealing: "Sellado de puerta",
      centerprofile: "Perfil central",
      labor: "Mano de obra",
      cuttingTime: "Corte",
      gluing: "Encolado de esquinas",
      mounting: "Montaje",
      timeMin: "Tiempo",
      cost: "Coste",
      steelband: "Steel band + fijación",
      steelbandPrice: "Precio steel band (2×)",
      steelbandPricePerM: "Precio steel band",
      steelbandLengthA: "Longitud A",
      steelbandLengthB: "Longitud B",
      drilling: "Perforación",
      popniets: "Remaches",
      totalPrice: "Precio total (2 puertas)",
      totalTime: "Tiempo total (2 puertas)",
      hint: "Estos valores representan el escenario «Antes».",
      sidesDiffer: "Distinguir puerta izquierda y derecha",
      leftDoor: "Puerta Izquierda · sellado + perfil central",
      rightDoor: "Puerta Derecha · sólo sellado",
      frameALenHint: "5.0m de sellado + 2.6m de perfil central",
      frameBLenHint: "7.6m de sellado (sin perfil central — sella contra puerta izquierda)",
    },
    primo: {
      title: "Solución Primo",
      subtitle: "Valores de nuestra solución — ajustables",
      profiles: "Perfiles (por metro)",
      doorsealing: "Sellado de puerta",
      centerprofile: "Perfil central",
      labor: "Mano de obra",
      weldingCutting: "Soldadura & corte",
      gluing: "Encolado",
      mounting: "Montaje",
      glue: "Pegamento/material (por puerta)",
      totalPrice: "Precio total (2 puertas)",
      totalTime: "Tiempo total (2 puertas)",
      hint: "Sin steel band. Solución prefabricada y más rápida.",
    },
    compare: {
      title: "Antes vs Después",
      subtitle: "Antes y después — por 2 puertas",
      current: "Situación Actual",
      primoSolution: "Solución Primo",
      priceBreakdown: "Composición del coste",
      timeBreakdown: "Composición del tiempo",
      profiles: "Perfiles",
      labor: "Mano de obra",
      materials: "Materiales",
      steelband: "Steel band",
    },
    reveal: {
      title: "Resultado de la Simulación",
      subtitle: "El ahorro que obtendrá tu cliente",
      pricePerSet: "Ahorro por 2 puertas",
      timePerSet: "Ahorro de tiempo por 2 puertas",
      annualSavings: "Ahorro anual estimado",
      fleetSavings: "Ahorro total en la flota",
      currentCost: "Coste actual",
      newCost: "Coste con Primo",
      reductionOf: "Reducción de",
      timeReduction: "Reducción de tiempo",
      basedOn: "Basado en {fleet} remolque(s) × {doors} puertas × {annual} unid./año",
      congrats: "Ahorro demostrado",
      cta: "Guardar & Exportar",
      shareTitle: "Compartir presentación",
    },
    saved: {
      title: "Simulaciones Guardadas",
      subtitle: "Consulta y recupera simulaciones anteriores",
      newBtn: "+ Nueva Simulación",
      search: "Buscar por cliente…",
      open: "Abrir",
      duplicate: "Duplicar",
      copySuffix: "(Copia)",
      empty: "Aún no hay simulaciones guardadas.",
      confirmDelete: "¿Eliminar simulación?",
      deleteWarning: "Esta acción no se puede deshacer.",
    },
    pdf: {
      headerTitle: "Análisis Técnico de Costes",
      headerSubtitle: "Sellado de puertas traseras · informe de ahorro",
      s1: "§1 Datos del cliente y remolque",
      client: "Cliente", contact: "Contacto", email: "Email", production: "Producción",
      doorHeight: "Altura de la puerta", doorWidth: "Ancho de la puerta", doorsPerTrailer: "Puertas / remolque", profile: "Perfil",
      notes: "Notas",
      s2: "§2 Configuración de las puertas", leftDoor: "Puerta Izquierda", rightDoor: "Puerta Derecha",
      leftDoorDesc: "Sellado {t}mm en las 3 aristas exteriores + perfil central {t}mm en la arista interior.",
      rightDoorDesc: "Sellado {t}mm en todo el perímetro. Sella contra el perfil central de la puerta izquierda.",
      dsLength: "Longitud sellado", cpLength: "Longitud perfil central",
      s3: "§3 Desglose de costes", component: "Componente", customer: "Cliente", primo: "Primo", savings: "Δ Ahorro",
      leftDoorProfiles: "Puerta Izquierda · sellado + perfil central", rightDoorProfiles: "Puerta Derecha · sólo sellado",
      cuttingWelding: "Corte / soldadura & corte", cornerGluing: "Encolado de esquinas", mounting: "Montaje",
      steelbandRow: "Steel band + perforación + remaches", glueRow: "Pegamento / material", eliminated: "— eliminado",
      totalSet: "Total (por conjunto de {n} puertas)",
      s4: "§4 Tiempo de mano de obra", operation: "Operación", totalLabour: "Tiempo total mano de obra",
      s5: "§5 Resumen de ahorro", perSet: "Por conjunto ({n} puertas)", annualised: "Anualizado",
      costReduction: "reducción de coste", saved: "ahorrado",
      execTitle: "Resumen Ejecutivo", execHeroLabel: "Ahorro demostrado",
      execPerDoors: "por {n} puertas", execCompareTitle: "Sin Primo vs Con Primo",
      beforePrimo: "Sin Primo", afterPrimo: "Con Primo",
      cost: "Coste", time: "Tiempo",
      costSavings: "Ahorro en Coste", timeSavings: "Ahorro en Tiempo",
      projectionPeriod: "Proyección {period}", projectionAnnual: "Proyección Anualizada",
      fleetTotalSavings: "Ahorro total en la flota", technicalDetail: "Detalle Técnico",
    },
  },

  "de": {
    app: {
      title: "Primo",
      subtitle: "Einsparungs-Simulator — Dichtungen für Kühlanhänger",
      newSimulation: "Neue Simulation",
      savedSimulations: "Gespeicherte Simulationen",
      settings: "Einstellungen",
      language: "Sprache",
    },
    home: {
      heroTag: "Hecktür-Dichtungssystem",
      heroTitle: "Ermitteln Sie die Einsparung in Ihrer Produktion",
      heroBody: "Ein visuelles, mehrstufiges Werkzeug, um Seite an Seite die aktuellen Produktionskosten und die Einsparung mit der Primo-Lösung zu vergleichen.",
      startBtn: "Simulation starten",
      viewSavedBtn: "Gespeicherte Simulationen ansehen",
      stat1: "Ø Einsparung",
      stat2: "Zeitersparnis",
      stat3: "Sprachen",
      per: "pro 2 Türen",
    },
    phases: {
      p1: "Konfiguration",
      p2: "Aktuelle Kosten",
      p3: "Primo-Lösung",
      p4: "Vorher vs. Nachher",
      p5: "Ergebnis",
      phaseOf: "Phase {n} von 5",
    },
    common: {
      back: "Zurück",
      next: "Weiter",
      finish: "Ergebnis anzeigen",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      close: "Schließen",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "Stk.",
      required: "Pflichtfeld",
      saved: "Simulation gespeichert",
      duplicated: "Simulation dupliziert",
      deleted: "Simulation gelöscht",
      loading: "Lädt…",
      empty: "Keine gespeicherten Simulationen.",
      error: "Ein Fehler ist aufgetreten.",
      clientRequired: "Bitte Kundennamen eingeben, bevor Sie speichern oder exportieren.",
      exportPdf: "PDF exportieren",
      restart: "Neue Simulation",
      goToPhase: "Zu Phase",
      created: "Erstellt",
      subtotal: "Zwischensumme",
    },
    client: {
      title: "Kundeninformationen",
      subtitle: "Identifizieren Sie den Kunden der Präsentation",
      company: "Firmenname",
      companyPh: "z. B. Kühltransporte GmbH",
      contact: "Ansprechpartner",
      contactPh: "z. B. Hans Müller",
      email: "E-Mail (optional)",
      emailPh: "hans@firma.de",
      notes: "Interne Notizen",
      notesPh: "Bemerkungen zum Meeting…",
    },
    trailer: {
      title: "Anhänger-Merkmale",
      subtitle: "Abmessungen und Produktionsvolumen konfigurieren",
      height: "Türhöhe",
      width: "Türbreite",
      doors: "Türen pro Anhänger",
      fleet: "Flotte (Anzahl Anhänger)",
      annual: "Anzahl produzierter Anhänger",
      period: "Produktionszeitraum",
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      annualPeriod: "Jährlich",
      quantityHint: "Anzahl neu produzierter Anhänger pro {period} (nicht mit der Flottengröße verwechseln)",
      hint: "Standardwerte: 2600 × 1200 mm.",
      layoutTitle: "Linke Tür + Rechte Tür",
      layoutBody: "Jeder Anhänger hat zwei unterschiedliche Rahmen. Rahmen A (links) hat Türdichtung (18mm ±2) an 3 Außenkanten (5,0m) plus Mittelprofil (25mm ±2) in der Mitte (2,6m). Rahmen B (rechts) hat nur Türdichtung entlang des gesamten Umfangs (7,6m) und dichtet gegen das Mittelprofil von Rahmen A ab. Wird pro Paar berechnet (2 Rahmen = 1 Anhänger).",
      dimensionsDiffer: "Unterschiedliche Abmessungen pro Tür",
      leftDim: "Linke Tür",
      rightDim: "Rechte Tür",

      profileSection: "Profil / Gummistärke",
      profilePreset: "Profil (mm)",
      profileChoose: "Profil auswählen",
      profileHint: "Ein Profil auszuwählen füllt die Kosten der folgenden Phasen automatisch aus.",
      hourlyRate: "Stundensatz (Arbeit)",
      hourlyRateHint: "Auf alle Vorgänge angewendet. Kosten = Zeit × €/h.",
      hourlyRateSection: "Arbeitskosten",
      managePresets: "Profile verwalten",    },
    customer: {
      title: "Aktuelle Kundenkosten",
      subtitle: "Aktuelle Lösung — Werte eingeben",
      profiles: "Profile (pro Meter)",
      doorsealing: "Türdichtung",
      centerprofile: "Mittelprofil",
      labor: "Arbeitsaufwand",
      cuttingTime: "Schneiden",
      gluing: "Eckverklebung",
      mounting: "Montage",
      timeMin: "Zeit",
      cost: "Kosten",
      steelband: "Steel band + Befestigung",
      steelbandPrice: "Steel band Preis (2×)",
      steelbandPricePerM: "Steel band Preis",
      steelbandLengthA: "Länge A",
      steelbandLengthB: "Länge B",
      drilling: "Bohren",
      popniets: "Nieten (popniets)",
      totalPrice: "Gesamtpreis (2 Türen)",
      totalTime: "Gesamtzeit (2 Türen)",
      hint: "Diese Werte entsprechen dem «Vorher»-Szenario.",
      sidesDiffer: "Linke und rechte Tür unterscheiden",
      leftDoor: "Linke Tür · Türdichtung + Mittelprofil",
      rightDoor: "Rechte Tür · nur Türdichtung",
      frameALenHint: "5,0m Türdichtung + 2,6m Mittelprofil",
      frameBLenHint: "7,6m Türdichtung (kein Mittelprofil — dichtet gegen linke Tür ab)",
    },
    primo: {
      title: "Primo Lösung",
      subtitle: "Werte unserer Lösung — anpassbar",
      profiles: "Profile (pro Meter)",
      doorsealing: "Türdichtung",
      centerprofile: "Mittelprofil",
      labor: "Arbeitsaufwand",
      weldingCutting: "Schweißen & Schneiden",
      gluing: "Verkleben",
      mounting: "Montage",
      glue: "Kleber (pro Tür)",
      totalPrice: "Gesamtpreis (2 Türen)",
      totalTime: "Gesamtzeit (2 Türen)",
      hint: "Ohne Steel band. Vorgefertigt und schneller.",
    },
    compare: {
      title: "Vorher vs. Nachher",
      subtitle: "Vorher und Nachher — pro 2 Türen",
      current: "Aktuelle Situation",
      primoSolution: "Primo Lösung",
      priceBreakdown: "Kostenaufteilung",
      timeBreakdown: "Zeitaufteilung",
      profiles: "Profile",
      labor: "Arbeitsaufwand",
      materials: "Material",
      steelband: "Steel band",
    },
    reveal: {
      title: "Simulationsergebnis",
      subtitle: "Die Einsparung, die Ihr Kunde erzielt",
      pricePerSet: "Ersparnis pro 2 Türen",
      timePerSet: "Zeitersparnis pro 2 Türen",
      annualSavings: "Geschätzte Jahresersparnis",
      fleetSavings: "Gesamteinsparung Flotte",
      currentCost: "Aktuelle Kosten",
      newCost: "Kosten mit Primo",
      reductionOf: "Reduktion von",
      timeReduction: "Zeitreduktion",
      basedOn: "Basierend auf {fleet} Anhänger × {doors} Türen × {annual} Stk./Jahr",
      congrats: "Einsparung nachgewiesen",
      cta: "Speichern & Exportieren",
      shareTitle: "Präsentation teilen",
    },
    saved: {
      title: "Gespeicherte Simulationen",
      subtitle: "Frühere Simulationen einsehen",
      newBtn: "+ Neue Simulation",
      search: "Nach Kunde suchen…",
      open: "Öffnen",
      duplicate: "Duplizieren",
      copySuffix: "(Kopie)",
      empty: "Noch keine gespeicherten Simulationen.",
      confirmDelete: "Simulation löschen?",
      deleteWarning: "Diese Aktion kann nicht rückgängig gemacht werden.",
    },
    pdf: {
      headerTitle: "Technische Kostenanalyse",
      headerSubtitle: "Hecktür-Dichtung · Einsparungsbericht",
      s1: "§1 Kunden- und Anhängerdaten",
      client: "Kunde", contact: "Kontakt", email: "E-Mail", production: "Produktion",
      doorHeight: "Türhöhe", doorWidth: "Türbreite", doorsPerTrailer: "Türen / Anhänger", profile: "Profil",
      notes: "Notizen",
      s2: "§2 Türkonfiguration", leftDoor: "Linke Tür", rightDoor: "Rechte Tür",
      leftDoorDesc: "Türdichtung {t}mm an 3 Außenkanten + Mittelprofil {t}mm an der Innenkante.",
      rightDoorDesc: "Türdichtung {t}mm am gesamten Umfang. Dichtet gegen das Mittelprofil der linken Tür ab.",
      dsLength: "Dichtungslänge", cpLength: "Mittelprofil-Länge",
      s3: "§3 Kostenaufschlüsselung", component: "Komponente", customer: "Kunde", primo: "Primo", savings: "Δ Einsparung",
      leftDoorProfiles: "Linke Tür · Dichtung + Mittelprofil", rightDoorProfiles: "Rechte Tür · nur Dichtung",
      cuttingWelding: "Schneiden / Schweißen & Schneiden", cornerGluing: "Eckverklebung", mounting: "Montage",
      steelbandRow: "Steel band + Bohren + Nieten", glueRow: "Kleber / Material", eliminated: "— entfällt",
      totalSet: "Gesamt (pro Satz von {n} Türen)",
      s4: "§4 Arbeitszeit", operation: "Vorgang", totalLabour: "Gesamte Arbeitszeit",
      s5: "§5 Einsparungsübersicht", perSet: "Pro Satz ({n} Türen)", annualised: "Jährlich",
      costReduction: "Kostenreduktion", saved: "gespart",
      execTitle: "Executive Summary", execHeroLabel: "Nachgewiesene Einsparung",
      execPerDoors: "pro {n} Türen", execCompareTitle: "Ohne Primo vs Mit Primo",
      beforePrimo: "Ohne Primo", afterPrimo: "Mit Primo",
      cost: "Kosten", time: "Zeit",
      costSavings: "Kostenersparnis", timeSavings: "Zeitersparnis",
      projectionPeriod: "Prognose {period}", projectionAnnual: "Jahresprognose",
      fleetTotalSavings: "Gesamteinsparung Flotte", technicalDetail: "Technisches Detail",
    },
  },

  "en": {
    app: {
      title: "Primo",
      subtitle: "Savings Simulator — Refrigerated Trailer Gaskets",
      newSimulation: "New Simulation",
      savedSimulations: "Saved Simulations",
      settings: "Settings",
      language: "Language",
    },
    home: {
      heroTag: "Back Door Gasket System",
      heroTitle: "Quantify the savings in your production",
      heroBody: "A visual, phased tool to compare, side by side, your current production cost and the savings achieved by adopting the Primo solution.",
      startBtn: "Start Simulation",
      viewSavedBtn: "View saved simulations",
      stat1: "Avg. savings",
      stat2: "Time saved",
      stat3: "Languages",
      per: "per 2 doors",
    },
    phases: {
      p1: "Configuration",
      p2: "Current Costs",
      p3: "Primo Solution",
      p4: "Before vs After",
      p5: "Result",
      phaseOf: "Phase {n} of 5",
    },
    common: {
      back: "Back",
      next: "Continue",
      finish: "See Result",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      close: "Close",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "units",
      required: "Required field",
      saved: "Simulation saved",
      duplicated: "Simulation duplicated",
      deleted: "Simulation deleted",
      loading: "Loading…",
      empty: "No saved simulations.",
      error: "An error occurred.",
      clientRequired: "Please enter the client name before saving or exporting.",
      exportPdf: "Export PDF",
      restart: "New Simulation",
      goToPhase: "Go to phase",
      created: "Created",
      subtotal: "Subtotal",
    },
    client: {
      title: "Client Information",
      subtitle: "Identify the client for this presentation",
      company: "Company name",
      companyPh: "e.g. ColdChain Ltd.",
      contact: "Contact person",
      contactPh: "e.g. John Smith",
      email: "Email (optional)",
      emailPh: "john@company.com",
      notes: "Internal notes",
      notesPh: "Meeting notes…",
    },
    trailer: {
      title: "Trailer Characteristics",
      subtitle: "Configure dimensions and production",
      height: "Door height",
      width: "Door width",
      doors: "Doors per trailer",
      fleet: "Customer fleet (# trailers)",
      annual: "Trailers produced",
      period: "Production period",
      weekly: "Weekly",
      monthly: "Monthly",
      annualPeriod: "Annual",
      quantityHint: "Units produced per {period}",
      hint: "Default values: 2600 × 1200 mm.",
      layoutTitle: "Left Door + Right Door",
      layoutBody: "Each trailer uses two different frames. Frame A (left) has doorsealing (18mm ±2) on its 3 outer edges (5.0m) plus the centre profile (25mm ±2) on the inner edge (2.6m). Frame B (right) uses doorsealing only, all around its perimeter (7.6m), and seals against left door's centre profile. Everything is counted per pair (2 frames = 1 trailer).",
      dimensionsDiffer: "Different dimensions per door",
      leftDim: "Left Door",
      rightDim: "Right Door",

      profileSection: "Profile / Rubber thickness",
      profilePreset: "Profile (mm)",
      profileChoose: "Choose profile",
      profileHint: "Selecting a profile pre-fills the costs of the following phases.",
      hourlyRate: "Hourly rate (labour)",
      hourlyRateHint: "Applied to every operation. Cost = time × €/h.",
      hourlyRateSection: "Labour Cost",
      managePresets: "Manage profiles",    },
    customer: {
      title: "Customer's Current Costs",
      subtitle: "Current solution — enter the values",
      profiles: "Profiles (per meter)",
      doorsealing: "Door sealing",
      centerprofile: "Center profile",
      labor: "Labor",
      cuttingTime: "Cutting",
      gluing: "Corner gluing",
      mounting: "Mounting",
      timeMin: "Time",
      cost: "Cost",
      steelband: "Steel band + hardware",
      steelbandPrice: "Steel band price (2×)",
      steelbandPricePerM: "Steel band price",
      steelbandLengthA: "Length A",
      steelbandLengthB: "Length B",
      drilling: "Drilling",
      popniets: "Rivets (popniets)",
      totalPrice: "Total price (2 doors)",
      totalTime: "Total time (2 doors)",
      hint: "These values represent the «Before» scenario.",
      sidesDiffer: "Distinguish left and right door",
      leftDoor: "Left Door · doorsealing + centre profile",
      rightDoor: "Right Door · doorsealing only",
      frameALenHint: "5.0m doorsealing + 2.6m centre profile",
      frameBLenHint: "7.6m doorsealing (no centre profile — seals against left door)",
    },
    primo: {
      title: "Primo Solution",
      subtitle: "Our solution values — adjustable",
      profiles: "Profiles (per meter)",
      doorsealing: "Door sealing",
      centerprofile: "Center profile",
      labor: "Labor",
      weldingCutting: "Welding & cutting",
      gluing: "Gluing",
      mounting: "Mounting",
      glue: "Glue/material (per door)",
      totalPrice: "Total price (2 doors)",
      totalTime: "Total time (2 doors)",
      hint: "No steel band. Pre-fabricated, faster to install.",
    },
    compare: {
      title: "Before vs After",
      subtitle: "Before and after — per 2 doors",
      current: "Current Situation",
      primoSolution: "Primo Solution",
      priceBreakdown: "Cost breakdown",
      timeBreakdown: "Time breakdown",
      profiles: "Profiles",
      labor: "Labor",
      materials: "Materials",
      steelband: "Steel band",
    },
    reveal: {
      title: "Simulation Result",
      subtitle: "The savings your customer will achieve",
      pricePerSet: "Savings per 2 doors",
      timePerSet: "Time savings per 2 doors",
      annualSavings: "Estimated annual savings",
      fleetSavings: "Total fleet savings",
      currentCost: "Current cost",
      newCost: "Cost with Primo",
      reductionOf: "Reduction of",
      timeReduction: "Time reduction",
      basedOn: "Based on {fleet} trailer(s) × {doors} doors × {annual} units/year",
      congrats: "Savings demonstrated",
      cta: "Save & Export",
      shareTitle: "Share presentation",
    },
    saved: {
      title: "Saved Simulations",
      subtitle: "Review and retrieve past simulations",
      newBtn: "+ New Simulation",
      search: "Search by client…",
      open: "Open",
      duplicate: "Duplicate",
      copySuffix: "(Copy)",
      empty: "No saved simulations yet.",
      confirmDelete: "Delete simulation?",
      deleteWarning: "This action cannot be undone.",
    },
    pdf: {
      headerTitle: "Technical Cost Analysis",
      headerSubtitle: "Back-door gasket · savings report",
      s1: "§1 Client & Trailer Specifications",
      client: "Client", contact: "Contact", email: "Email", production: "Production",
      doorHeight: "Door height", doorWidth: "Door width", doorsPerTrailer: "Doors / trailer", profile: "Profile",
      notes: "Notes",
      s2: "§2 Door Layout", leftDoor: "Left Door", rightDoor: "Right Door",
      leftDoorDesc: "Doorsealing {t}mm on 3 outer edges + centre profile {t}mm at the inner edge.",
      rightDoorDesc: "Doorsealing {t}mm around the entire perimeter. Seals against left door's centre profile.",
      dsLength: "Doorsealing length", cpLength: "Centre profile length",
      s3: "§3 Cost Breakdown", component: "Component", customer: "Customer", primo: "Primo", savings: "Δ Savings",
      leftDoorProfiles: "Left Door · doorsealing + centre profile", rightDoorProfiles: "Right Door · doorsealing only",
      cuttingWelding: "Cutting / welding & cutting", cornerGluing: "Corner gluing", mounting: "Mounting",
      steelbandRow: "Steel band + drilling + rivets", glueRow: "Glue / material", eliminated: "— eliminated",
      totalSet: "Total (per set of {n} doors)",
      s4: "§4 Labour Time", operation: "Operation", totalLabour: "Total labour time",
      s5: "§5 Savings Summary", perSet: "Per set ({n} doors)", annualised: "Annualised",
      costReduction: "cost reduction", saved: "saved",
      execTitle: "Executive Summary", execHeroLabel: "Demonstrated savings",
      execPerDoors: "per {n} doors", execCompareTitle: "Without Primo vs With Primo",
      beforePrimo: "Without Primo", afterPrimo: "With Primo",
      cost: "Cost", time: "Time",
      costSavings: "Cost savings", timeSavings: "Time savings",
      projectionPeriod: "{period} projection", projectionAnnual: "Annualised projection",
      fleetTotalSavings: "Total fleet savings", technicalDetail: "Technical Detail",
    },
  },
  "it": {
    app: {
      title: "Primo",
      subtitle: "Simulatore di Risparmio — Guarnizioni per Rimorchi Refrigerati",
      newSimulation: "Nuova Simulazione",
      savedSimulations: "Simulazioni Salvate",
      settings: "Impostazioni",
      language: "Lingua",
    },
    home: {
      heroTag: "Sistema di Guarnizione per Porte Posteriori",
      heroTitle: "Quantifica il risparmio nella tua produzione",
      heroBody: "Uno strumento visivo e per fasi per confrontare, fianco a fianco, il costo attuale della tua produzione e il risparmio ottenuto adottando la soluzione Primo.",
      startBtn: "Avvia Simulazione",
      viewSavedBtn: "Vedi simulazioni salvate",
      stat1: "Risparmio medio",
      stat2: "Tempo risparmiato",
      stat3: "Lingue",
      per: "per 2 porte",
    },
    phases: {
      p1: "Configurazione",
      p2: "Costi Attuali",
      p3: "Soluzione Primo",
      p4: "Prima vs Dopo",
      p5: "Risultato",
      phaseOf: "Fase {n} di 5",
    },
    common: {
      back: "Indietro",
      next: "Continua",
      finish: "Vedi Risultato",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      close: "Chiudi",
      currency: "€",
      minutes: "min",
      mm: "mm",
      perMeter: "€/m",
      units: "unità",
      required: "Campo obbligatorio",
      saved: "Simulazione salvata",
      duplicated: "Simulazione duplicata",
      deleted: "Simulazione eliminata",
      loading: "Caricamento…",
      empty: "Nessuna simulazione salvata.",
      error: "Si è verificato un errore.",
      clientRequired: "Inserisci il nome del cliente prima di salvare o esportare.",
      exportPdf: "Esporta PDF",
      restart: "Nuova Simulazione",
      goToPhase: "Vai alla fase",
      created: "Creato",
      subtotal: "Subtotale",
    },
    client: {
      title: "Informazioni Cliente",
      subtitle: "Identifica il cliente per questa presentazione",
      company: "Nome dell'azienda",
      companyPh: "Es. TransFreddo Srl.",
      contact: "Persona di contatto",
      contactPh: "Es. Mario Rossi",
      email: "Email (opzionale)",
      emailPh: "mario@azienda.it",
      notes: "Note interne",
      notesPh: "Note della riunione…",
    },
    trailer: {
      title: "Caratteristiche del Rimorchio",
      subtitle: "Configura le dimensioni e il volume di produzione",
      height: "Altezza della porta",
      width: "Larghezza della porta",
      doors: "Porte per rimorchio",
      fleet: "Flotta del cliente (n° rimorchi)",
      annual: "Produzione (unità)",
      period: "Periodo di produzione",
      weekly: "Settimanale",
      monthly: "Mensile",
      annualPeriod: "Annuale",
      quantityHint: "Unità prodotte per {period}",
      hint: "Valori predefiniti basati sulle dimensioni standard: 2600 × 1200 mm.",
      layoutTitle: "Porta Sinistra + Porta Destra",
      layoutBody: "Ogni rimorchio ha due telai diversi. Il Telaio A (sinistra) ha una guarnizione (18mm ±2) sui 3 lati esterni (5,0m) più il profilo centrale (25mm ±2) al centro (2,6m). Il Telaio B (destra) ha solo la guarnizione lungo tutto il perimetro (7,6m) e sigilla contro il profilo centrale del Telaio A. Si contabilizza a coppia (2 telai = 1 rimorchio).",
      dimensionsDiffer: "Dimensioni diverse per porta",
      leftDim: "Porta Sinistra",
      rightDim: "Porta Destra",

      profileSection: "Profilo / Spessore della gomma",
      profilePreset: "Profilo (mm)",
      profileChoose: "Scegli profilo",
      profileHint: "Selezionare un profilo pre-compila i costi delle fasi successive.",
      hourlyRate: "Valore orario (manodopera)",
      hourlyRateHint: "Applicato a tutte le operazioni. Costo = tempo × €/h.",
      hourlyRateSection: "Costo della Manodopera",
      managePresets: "Gestisci profili",
    },
    customer: {
      title: "Costi Attuali del Cliente",
      subtitle: "Soluzione attualmente utilizzata — inserisci i valori praticati",
      profiles: "Profili (al metro)",
      doorsealing: "Guarnizione porta",
      centerprofile: "Profilo centrale",
      labor: "Manodopera",
      cuttingTime: "Taglio",
      gluing: "Incollaggio angoli",
      mounting: "Montaggio",
      timeMin: "Tempo",
      cost: "Costo",
      steelband: "Steel band + fissaggio",
      steelbandPrice: "Prezzo steel band (2×)",
      steelbandPricePerM: "Prezzo steel band",
      steelbandLengthA: "Lunghezza A",
      steelbandLengthB: "Lunghezza B",
      drilling: "Foratura",
      popniets: "Rivetti (popniets)",
      totalPrice: "Prezzo totale (2 porte)",
      totalTime: "Tempo totale (2 porte)",
      hint: "Questi valori rappresentano la situazione attuale — lo scenario «Prima».",
      sidesDiffer: "Distinguere porta sinistra e destra",
      leftDoor: "Porta Sinistra · guarnizione + profilo centrale",
      rightDoor: "Porta Destra · solo guarnizione",
      frameALenHint: "5,0m di guarnizione + 2,6m di profilo centrale",
      frameBLenHint: "7,6m di guarnizione (senza profilo centrale — sigilla contro la porta sinistra)",
    },
    primo: {
      title: "Soluzione Primo",
      subtitle: "Valori della nostra soluzione — regolabili secondo l'offerta",
      profiles: "Profili (al metro)",
      doorsealing: "Guarnizione porta",
      centerprofile: "Profilo centrale",
      labor: "Manodopera",
      weldingCutting: "Saldatura & taglio",
      gluing: "Incollaggio",
      mounting: "Montaggio",
      glue: "Colla/materiale (per porta)",
      totalPrice: "Prezzo totale (2 porte)",
      totalTime: "Tempo totale (2 porte)",
      hint: "Senza steel band. Soluzione prefabbricata e più rapida da installare.",
    },
    compare: {
      title: "Prima vs Dopo",
      subtitle: "Prima e dopo — per 2 porte",
      current: "Situazione Attuale",
      primoSolution: "Soluzione Primo",
      priceBreakdown: "Composizione dei costi",
      timeBreakdown: "Composizione dei tempi",
      profiles: "Profili",
      labor: "Manodopera",
      materials: "Materiali",
      steelband: "Steel band",
    },
    reveal: {
      title: "Risultato della Simulazione",
      subtitle: "Il risparmio che otterrà il tuo cliente",
      pricePerSet: "Risparmio per 2 porte",
      timePerSet: "Risparmio di tempo per 2 porte",
      annualSavings: "Risparmio annuo stimato",
      fleetSavings: "Risparmio totale per la flotta",
      currentCost: "Costo attuale",
      newCost: "Costo con Primo",
      reductionOf: "Riduzione del",
      timeReduction: "Riduzione tempo",
      basedOn: "Basato su {fleet} rimorchio(i) × {doors} porte × {annual} unità/anno",
      congrats: "Risparmio dimostrato",
      cta: "Salva ed Esporta",
      shareTitle: "Condividi presentazione",
    },
    saved: {
      title: "Simulazioni Salvate",
      subtitle: "Consulta e recupera simulazioni passate",
      newBtn: "+ Nuova Simulazione",
      search: "Cerca per cliente…",
      open: "Apri",
      duplicate: "Duplica",
      copySuffix: "(Copia)",
      empty: "Ancora nessuna simulazione salvata.",
      confirmDelete: "Eliminare simulazione?",
      deleteWarning: "Questa azione non può essere annullata.",
    },
    pdf: {
      headerTitle: "Analisi Tecnica dei Costi",
      headerSubtitle: "Guarnizione porta posteriore · rapporto di risparmio",
      s1: "§1 Specifiche Cliente e Rimorchio",
      client: "Cliente", contact: "Contatto", email: "Email", production: "Produzione",
      doorHeight: "Altezza porta", doorWidth: "Larghezza porta", doorsPerTrailer: "Porte / rimorchio", profile: "Profilo",
      notes: "Note",
      s2: "§2 Configurazione Porte", leftDoor: "Porta Sinistra", rightDoor: "Porta Destra",
      leftDoorDesc: "Guarnizione {t}mm sui 3 lati esterni + profilo centrale {t}mm sul lato interno.",
      rightDoorDesc: "Guarnizione {t}mm lungo tutto il perimetro. Sigilla contro il profilo centrale della porta sinistra.",
      dsLength: "Lunghezza guarnizione", cpLength: "Lunghezza profilo centrale",
      s3: "§3 Composizione dei Costi", component: "Componente", customer: "Cliente", primo: "Primo", savings: "Δ Risparmio",
      leftDoorProfiles: "Porta Sinistra · guarnizione + profilo centrale", rightDoorProfiles: "Porta Destra · solo guarnizione",
      cuttingWelding: "Taglio / saldatura & taglio", cornerGluing: "Incollaggio angoli", mounting: "Montaggio",
      steelbandRow: "Steel band + foratura + rivetti", glueRow: "Colla / materiale", eliminated: "— eliminato",
      totalSet: "Totale (per set di {n} porte)",
      s4: "§4 Tempo di Manodopera", operation: "Operazione", totalLabour: "Tempo di manodopera totale",
      s5: "§5 Riepilogo Risparmio", perSet: "Per set ({n} porte)", annualised: "Annualizzato",
      costReduction: "riduzione dei costi", saved: "risparmiato",
      execTitle: "Riepilogo Esecutivo", execHeroLabel: "Risparmio dimostrato",
      execPerDoors: "per {n} porte", execCompareTitle: "Senza Primo vs Con Primo",
      beforePrimo: "Senza Primo", afterPrimo: "Con Primo",
      cost: "Costo", time: "Tempo",
      costSavings: "Risparmio sui costi", timeSavings: "Risparmio di tempo",
      projectionPeriod: "Proiezione {period}", projectionAnnual: "Proiezione annualizzata",
      fleetTotalSavings: "Risparmio totale sulla flotta", technicalDetail: "Dettaglio Tecnico",
    },
  },
};

// Helper: get value by dotted path from translations object
export function t(lang, path, params = {}) {
  const dict = translations[lang] || translations["en"];
  const parts = path.split(".");
  let val = dict;
  for (const p of parts) {
    if (val == null) break;
    val = val[p];
  }
  if (typeof val !== "string") return path;
  return val.replace(/\{(\w+)\}/g, (_, k) => (params[k] != null ? params[k] : ""));
}
